export type LoanStatusRestrictionType =
  | 'structure'
  | 'loanDetail'
  | 'application'
  | 'submission'
  | 'overview'
  | 'underwriting'
  | 'tasks'
  | 'budget'

export const LoanStatusRestrictionTypes: LoanStatusRestrictionType[] = [
  'structure',
  'loanDetail',
  'application',
  'submission',
  'overview',
  'underwriting',
  'tasks',
  'budget',
]

export const LoanStatusRestrictionTextMap: Record<string, string> = {
  // structure
  interestRateBasePrice: `Interest Rate and Base Price`,
  loanAmountMaxLimit: `The Loan Amount exceeds the Maximum Limit`,
  mustBeLocked: `Must be Locked`,
  lockExpired: `Lock Expired. Relock is required!`,
  loanDetailValidation: `Loan Detail Validation & Override`,
  loanPricingReviewBorrowerProceed: `Loan Pricing Review Borrower Proceed`,

  // loan detail
  visibleFieldRequired: 'Loan Structure Visible Field Required',
  estimatedClosingAmount: 'Estimated Closing Amount restriction',
  constructionFinancedHoldbackRange:
    'Construction Financed Holdback must be in minConstructionFinancedHoldback% - maxConstructionFinancedHoldback%.',
  totalRehabFinancedRange: 'Total Rehab Financed must be in minTotalRehabFinanced% - maxTotalRehabFinanced%.',
  proposedLoanAmountRange: 'Proposed Loan Amount must be in minProposedLoanAmount - maxProposedLoanAmount.',
  minimumAsIsValue: 'Minimum As Is Value is ...',
  closingCostEstimateMustEqualFeeWorksheet: 'The Closing Cost Estimate must be equal to the value in Fee Worksheet.',
  minimumEstimatedCreditScore: 'The minimum Estimated Credit Score is ...',
  estimatedCreditScoreRange: `The Estimated Credit Score(estimatedCreditScore) must be equal to the middle score(middleValue) of Borrowers.`,
  afterRepairValueMustBeAtLeastMinARV: 'After Repair Value must be at least minARV.',
  numberOfPropertiesRange: 'The number of properties must be ...',

  // application
  atLeastExpTrackRecords: `At least [Experience] Track Records`,
  pendingAssets: `Pending Assets Verification`,

  // submission
  unclearedPTD: `Uncleared PTD Conditions exist.`,
  unclearedPTF: `Uncleared PTF Conditions exist.`,
  unclearedPTDInternal: `Uncleared PTD - Internal Conditions exist.`,
  unclearedLoanIntake: 'Uncleared Loan Intake Conditions exist.',
  loanClosingDate: `Loan Closing Date`,
  ineligiblePartyCleared: `Ineligible Party Clearance`,

  // overview
  party: `Party -> [Errors]`,

  // underwriting
  expDateInfo: `Expiration Date Information`,
  summaryInfo: `Underwriting Summary Information`,
  asIsValueLessThanAsIsAppraisedValue: 'As-Is Value must be less than or equal to As-Is Appraised Value',
  afterRepairValueLessThanAfterRepairAppraisedValue:
    'After-Repair Value must be less than or equal to After-Repair Appraised Value',

  // tasks
  loanChangeRequest: 'Loan Change Request',
  revalidationReviewLockDesk: 'Revalidation Review LockDesk',
  revalidationReviewUnderwriter: 'Revalidation Review Underwriter',
  exceptionReviewRequest: 'UW Loan Structure Exception Review Request',
  loanStructureChangeRequest: 'Loan Structure Change Request',
  rateLock: 'Initial Rate Lock',
  reLockRate: 'ReLock Rate',

  // budget
  estimateNotMatch: `Construction Budget and Grand Total of Rehab Cost Borrower Estimated do not match`,
}

export const unclearedCategoryRestrictionPrefix = 'unclearedCategory:'

export const loanStatusRestrictionLabel = (key: string, label?: string) => {
  if (label) return label
  if (LoanStatusRestrictionTextMap[key]) return LoanStatusRestrictionTextMap[key]
  if (key.startsWith(unclearedCategoryRestrictionPrefix)) {
    return `Uncleared ${key.slice(unclearedCategoryRestrictionPrefix.length)} Conditions exist.`
  }
  return ''
}

export interface LoanStatusRestriction {
  key: string
  loanStatus: string[]
  enabled: boolean
  /** Resolved by the API from the category's current title; not edited locally. */
  label?: string
}

export type LoanStatusRectrictionConfigType = Record<LoanStatusRestrictionType, LoanStatusRestriction[]>
